import { module } from 'modujs';
import Swiper from 'swiper';
import { Navigation, Thumbs, FreeMode, Pagination } from 'swiper/modules';

export default class extends module {
    constructor(m) {
        super(m);

        const swiperContainers = this.el.querySelectorAll('[data-swiper="swiper"]');

        swiperContainers.forEach((swiperContainer) => {
            let dataOptions = swiperContainer.closest('[data-module-swiper]').getAttribute('data-options');
            dataOptions = JSON.parse(dataOptions.replace(/'/g, '"'));

            const swiperInstance = new Swiper(swiperContainer, {
                modules: [Navigation, Thumbs, FreeMode, Pagination],
                spaceBetween: 50,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                ...dataOptions,
            });

            const videos = swiperContainer.querySelectorAll('video[data-swiper="video"]');

            // 🔁 Slide change events (όπως πριν)
            swiperInstance.on('slideChange', () => {
                if (videos) {
                    videos.forEach((video, index) => {
                        const slide = video.closest('.swiper-slide');
                        const btnPlay = slide.querySelector('[data-swiper="play"]');
                        const btnPause = slide.querySelector('[data-swiper="pause"]');

                        if (index === swiperInstance.activeIndex) {
                            if (video.paused) video.play().catch(() => { });
                        } else {
                            if (!video.paused) {
                                video.pause();
                                // Όταν φύγουμε από το slide, φρόντισε να φαίνεται το play πάλι
                                if (btnPlay && btnPause) {
                                    btnPlay.classList.remove('hidden');
                                    btnPause.classList.add('hidden');
                                }
                            }
                        }
                    });
                }
            });

            swiperInstance.on('afterInit', () => {
                const activeVideo = videos[swiperInstance.activeIndex];
                if (activeVideo && activeVideo.paused) activeVideo.play().catch(() => { });
            });

            const playButtons = swiperContainer.querySelectorAll('[data-swiper="play"]');
            const pauseButtons = swiperContainer.querySelectorAll('[data-swiper="pause"]');

            if (playButtons) {
                playButtons.forEach((btnPlay) => {
                    btnPlay.addEventListener('click', () => {
                        const slide = btnPlay.closest('.swiper-slide');
                        const btnPause = slide.querySelector('[data-swiper="pause"]');
                        this.playVideo(slide, btnPlay, btnPause);
                    });
                });
            }

            if (pauseButtons) {
                pauseButtons.forEach((btnPause) => {
                    btnPause.addEventListener('click', () => {
                        const slide = btnPause.closest('.swiper-slide');
                        const btnPlay = slide.querySelector('[data-swiper="play"]');
                        this.pauseVideo(slide, btnPlay, btnPause);
                    });
                });
            }
        });
    }


    playVideo(slide, btnPlay, btnPause) {
        const video = slide.querySelector('video[data-swiper="video"]');
        if (!video) return;

        video.play().catch(() => { });
        if (btnPlay) btnPlay.classList.add('hidden');
        if (btnPause) btnPause.classList.remove('hidden');
    }


    pauseVideo(slide, btnPlay, btnPause) {
        const video = slide.querySelector('video[data-swiper="video"]');
        if (!video) return;

        video.pause();
        if (btnPlay) btnPlay.classList.remove('hidden');
        if (btnPause) btnPause.classList.add('hidden');
    }
}
